<div class="matrix-grid-scroll" (mouseleave)="highlight(null, null)">
  <div
    class="matrix-grid"
    role="table"
    data-testid="matrix-grid"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-busy]="loading()"
    [style.grid-template-columns]="gridTemplateColumns()"
  >
    <div role="row" class="contents">
      @for (column of columns(); track column.id) {
        <div
          role="columnheader"
          class="matrix-grid-cell matrix-grid-header"
          data-testid="matrix-grid-header"
          tabindex="-1"
          [attr.data-column-id]="column.id"
          [attr.aria-sort]="getAriaSort(column.id)"
          [class.is-sticky]="column.sticky"
          [class.is-last-sticky]="column.id === lastStickyId()"
          [class.is-collapsed]="isCollapsed(column.id)"
          [class.is-column-highlighted]="hoveredColumnId() === column.id"
          [style.left]="stickyLeft().get(column.id) ?? null"
          (mouseenter)="highlight(null, column.id)"
          (focusin)="highlight(null, column.id)"
        >
          @if (isCollapsed(column.id)) {
            <button
              type="button"
              class="matrix-grid-stub"
              data-testid="matrix-grid-stub"
              [attr.aria-label]="'shared.matrixGrid.expandColumn' | translate: { name: column.label }"
              [matTooltip]="'shared.matrixGrid.expandColumn' | translate: { name: column.label }"
              (click)="expandColumn(column.id)"
            >
              <app-icon src="/icons/arrows-horizontal.svg" alt="" color="currentColor" [size]="14" />
            </button>
          } @else {
            <ng-container *ngTemplateOutlet="headerDef().template; context: { $implicit: column }" />
          }
        </div>
      }
      <div class="matrix-grid-cell matrix-grid-header" aria-hidden="true" data-testid="matrix-grid-filler"></div>
    </div>

    @if (loading()) {
      @for (index of skeletonRowIds(); track index) {
        <div role="row" class="contents">
          @for (column of columns(); track column.id) {
            <div
              role="cell"
              class="matrix-grid-cell"
              [class.is-sticky]="column.sticky"
              [class.is-last-sticky]="column.id === lastStickyId()"
              [style.left]="stickyLeft().get(column.id) ?? null"
            >
              <!-- As tall as a row's usual content (28px avatar / icon button), so rows keep their height on load. -->
              <div class="flex min-h-7 items-center">
                <ngx-skeleton-loader class="w-full" [theme]="{ height: '20px', margin: '0', width: '100%' }" />
              </div>
            </div>
          }
          <div class="matrix-grid-cell" aria-hidden="true"></div>
        </div>
      }
    } @else {
      @for (row of rows(); track row.id) {
        <div role="row" class="contents" data-testid="matrix-grid-row" [attr.data-row-id]="row.id">
          @for (column of columns(); track column.id) {
            <div
              role="cell"
              class="matrix-grid-cell"
              data-testid="matrix-grid-cell"
              [attr.data-column-id]="column.id"
              [class.is-sticky]="column.sticky"
              [class.is-last-sticky]="column.id === lastStickyId()"
              [class.is-collapsed]="isCollapsed(column.id)"
              [class.is-row-highlighted]="hoveredRowId() === row.id"
              [class.is-column-highlighted]="hoveredColumnId() === column.id"
              [style.left]="stickyLeft().get(column.id) ?? null"
              (mouseenter)="highlight(row.id, column.id)"
              (focusin)="highlight(row.id, column.id)"
            >
              <ng-container
                *ngTemplateOutlet="
                  cellDef().template;
                  context: {
                    $implicit: row,
                    collapsed: isCollapsed(column.id),
                    column: column,
                    expanded: isRowExpanded(row.id),
                  }
                "
              />

              @if (isRowExpanded(row.id) && expandedDef() && !isCollapsed(column.id)) {
                <div class="mt-3" data-testid="matrix-grid-expanded">
                  <ng-container
                    *ngTemplateOutlet="
                      expandedDef()!.template;
                      context: { $implicit: row, collapsed: false, column: column, expanded: true }
                    "
                  />
                </div>
              }
            </div>
          }
          <div
            class="matrix-grid-cell"
            aria-hidden="true"
            [class.is-row-highlighted]="hoveredRowId() === row.id"
            (mouseenter)="highlight(row.id, null)"
          ></div>
        </div>
      }

      @if (footerDef() && rows().length) {
        <div role="row" class="contents" data-testid="matrix-grid-footer">
          @for (column of columns(); track column.id) {
            <div
              role="cell"
              class="matrix-grid-cell matrix-grid-footer"
              [attr.data-column-id]="column.id"
              [class.is-sticky]="column.sticky"
              [class.is-last-sticky]="column.id === lastStickyId()"
              [class.is-collapsed]="isCollapsed(column.id)"
              [class.is-column-highlighted]="hoveredColumnId() === column.id"
              [style.left]="stickyLeft().get(column.id) ?? null"
              (mouseenter)="highlight(null, column.id)"
            >
              <ng-container
                *ngTemplateOutlet="
                  footerDef()!.template;
                  context: { $implicit: column, collapsed: isCollapsed(column.id) }
                "
              />
            </div>
          }
          <div
            class="matrix-grid-cell matrix-grid-footer"
            aria-hidden="true"
            (mouseenter)="highlight(null, null)"
          ></div>
        </div>
      }
    }
  </div>
</div>
